import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Form, getFieldProps, Inputs, Label, Modal } from '@crx-dev/hss-react-components';
import { useUserInfo } from '../../../Infrastructure/auth/UseUserInfo';

interface LocumUserRegisterFormProps {
    onSuccess: () => void;
    onCancel: () => void;
}

function LocumUserRegisterForm({ onCancel, onSuccess }: LocumUserRegisterFormProps) {
    const userInfo = useUserInfo();

    const formik = useFormik({
        initialValues: {
            firstName: '',
            surName: '',
            gPHCNumber: ''
        },
        validationSchema: yup.object().shape({
            firstName: yup
                .string()
                .required('Required')
                .matches(/^\S*$/, 'Whitespace is not allowed'),
            surName: yup
                .string()
                .required('Required')
                .matches(/^\S*$/, 'Whitespace is not allowed'),
            gPHCNumber: yup
                .string()
                .required('Required')
                .matches(/^\d+$/, 'Numbers only')
        }),
        onSubmit: async values => {
            userInfo.setLocumUserName(
                `${values.firstName.trim()} ${values.surName.trim()} (${values.gPHCNumber.trim()})`
            );
            onSuccess();
        }
    });

    return (
        <Modal onCancel={() => {}} open={true} title="Locum Details">
            <Form onSubmit={formik.handleSubmit}>
                <br />
                <>
                    <Label label="First Name" htmlFor="firstName" />
                    <Inputs.Text {...getFieldProps(formik, 'firstName')} />
                </>
                <>
                    <Label label="Surname" htmlFor="surName" />
                    <Inputs.Text {...getFieldProps(formik, 'surName')} />
                </>
                <>
                    <Label label="GPHC Number" htmlFor="gPHCNumber" />
                    <Inputs.Text {...getFieldProps(formik, 'gPHCNumber')} />
                </>
                <Form.Footer
                    onCancel={onCancel}
                    cancelButtonLabel="Logout"
                    submitError={formik.isSubmitting && !formik.isValid}
                    submitButtonLabel="Continue"
                />
            </Form>
        </Modal>
    );
}

export default LocumUserRegisterForm;
